












/* Created- 03 - Sep - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { CustomerUrlModel } from "../../Generated/ParticaAPI";
@Component(
	{
		name: "ParticaWebsiteCard"
	})
export default class ParticaWebsiteCard extends Vue {
	@Prop() private data: CustomerUrlModel; // your data   
	private icon: string = "";
	private getPublication(): string {
		if (this.data !== undefined) {
			// @ts-ignore
			return this.data.publicationCustomerUrls[0].publication.name;
		}
		return "Unknown";
	}
	private geterrimg() {
		this.icon = "https://dashboard.partica.online/app2/img/no-image.jpg";
	}
	private gotoWebsite() {
		// @ts-ignore
		if (this.data !== undefined) {
			this.$router.push(`/website/${this.data.id}/`);
		}
	}
	private gotoTitle() {
		// @ts-ignore
		if (this.data !== undefined && this.data.publicationCustomerUrls.length > 0) {
			// @ts-ignore
			this.$router.push(`/title/${this.data.publicationCustomerUrls[0].publicationId}/`);
		}
	}
	private mounted() {
		// @ts-ignore
		if (this.data !== undefined && this.data.publicationCustomerUrls.length > 0) {
			// @ts-ignore
			this.icon = `${this.$store.state.config.thumburl}sites/${this.data.url.substring(8)}/${this.data.publicationCustomerUrls[0].publication.guid}/icon.png`;
		}
	}
}
